export default __webpack_public_path__ + "static/media/close_button.2bbd328b.svg";